import { DescargaService } from './../_services/descargas.service';
import { DescargaRespuesta } from './../_models/descargas';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resoluciones',
  templateUrl: './resoluciones.component.html',
  styleUrls: ['./resoluciones.component.css']
})
export class ResolucionesComponent implements OnInit {

  respuesta: DescargaRespuesta = new DescargaRespuesta();
  panelAbierto: { [key: string]: boolean } = {}; // 👈 clave nueva

  constructor(private service: DescargaService) {}

  ngOnInit() {
  this.service.getAll('files-resoluciones').subscribe(
    datos => {
      this.respuesta = datos;

      // 👉 Sort categories by fecha (newest first)
      this.respuesta.registros.sort((a: any, b: any) => {
        const dateA = new Date(a.fecha).getTime();
        const dateB = new Date(b.fecha).getTime();
        return dateB - dateA; // newer first
      });

//        this.respuesta = datos;

        // Inicializar todos los paneles como cerrados
        this.respuesta.registros.forEach((categoria: any) => {
          this.panelAbierto[categoria.nombre] = true;
        });
      }
    );
  }

  togglePanel(nombre: string): void {
    this.panelAbierto[nombre] = !this.panelAbierto[nombre];
  }

  isPanelAbierto(nombre: string): boolean {
    return this.panelAbierto[nombre];
  }
}